import { PushPin } from '@phosphor-icons/react';

export default PushPin;
